module.exports = __webpack_public_path__ + "img/projects_logo7.dca29bb7.jpg";